import PedidoCompraAPI from '@/api/compra/pedido';

export default {
  namespaced: true,
  actions: {
    fetch_pedido_compra(_, params) {
      return PedidoCompraAPI.index(params);
    },
  },
};
